import { validatePresence } from 'ember-changeset-validations/validators';

export default {
  username: validatePresence({ presence: true, message: "Can't be blank" }),
  password: validatePresence({ presence: true, message: "Can't be blank" }),
  tntOrganizationId: validatePresence({
    presence: true,
    message: "Contact can't be blank",
  }),
};
